export default __webpack_public_path__ + "static/media/vaibhav.4b547c54.jpg";